import Vue from 'vue'
Vue.component('footer-cont', {
  props: ['buylink'],
  data(){
	  return {
      requestQuote_submit:'확인',
      quantity_error_msg:'입력하십시오',
		  langlist: [],
		  colunmlist:[],
			xname:'',
			name_error:'',
			company:'',
			company_error:'',
			phone:'',
			phone_error:'',
			email:'',
      email_error:'',
      quantity:'',
      quantity_error:'',
			softwareVersion:1,
		    duration:2
	  }
  },
  created:function(){
		var self = this;
		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchLanguage',
			  data: {productId:ProductId,pageNo:0,pageSize:10},
			  'Content-Type':"application/json",
			  success:function(res){
				  $.each(res.bizData.list,function(i,v){
					  var linkurl;
					  if(v.code=='en'){
						  linkurl = '../index.html';
					  }
					  if(v.code=='jp'){
						  linkurl = '../jp/index.html';
					  }
					  if(v.code=='es'){
						  linkurl = '../es/index.html';
					  }
					  if(v.code=='kr'){
						  linkurl = '../kr/index.html';
					  }
					  res.bizData.list[i].linkurl = linkurl;


				  })
				  self.langlist = res.bizData.list;
			  }
		  })

		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchContent ',
			  data: {productId:ProductId,channelCode:'case',lang:'kr',pageNo:0,pageSize:3},
			  'Content-Type':"application/json",
			  success:function(res){
				  self.colunmlist = res.bizData.list;
			  }
		   })
  },
  methods:{

	//新增报价申请

		requestQuote:function(){
			var self = this;
			var email = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			//var mobile=/^1[3|4|5|8][0-9]\d{4,8}$/;

			if(self.xname==""){
        self.name_error = true;
        //return false;
			}

			if(self.company==""){
				self.company_error = true;
				//return false;
			}

			if(!email.test(self.email) || self.email==""){

				self.email_error = true;
				//return false;

			}

			if(self.phone==""){// || !mobile.test(self.phone)

				self.phone_error = true;
        //return false;

      }
      if(self.quantity==""){

        self.quantity_error = true;
        self.quantity_error_msg='입력하십시오';
        //return false;

      }
      if(!/^[1-9]\d*$/.test(self.quantity)) {
        self.quantity_error = true;
        self.quantity_error_msg='숫자 입력해주세요.';
			}

      if(self.name_error||self.company_error||self.email_error||self.phone_error||self.quantity_error){

        return false;
      }
      self.requestQuote_submit='제출 중'
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/requestQuote',
			  data: {
          name:self.xname,
          companyName:self.company,
          email:self.email,
          mobile:self.phone,
          softwareVersion:self.softwareVersion,
          duration:self.duration,
          lang:'kr',
          quantity:self.quantity
        },
			  'Content-Type':"application/json",
			  success:function(res){
            console.log(res)
				  if(res.rtnCode=='0000000'){

					  alert('귀하의 메시시를 받았으며 가능한 빨리 답변 드리도록 하겠습니다.');
					  window.location.href="index.html";

				  }else{
            alert('서버 문제가 생기면 다시 시도해 보십시오.');
          }
          self.requestQuote_submit='확인'
			  }
		   })

		},
    googleBuyNow:function(){//buyNow
      gtag_report_conversion_buyNow();
	  },
    googleDownload:function(){//download
      gtag_report_conversion_download();
    },

   },
  template: '<div><div class="footer">\
  <div class="top or mainbox">\
   <h2 class="wow bounceInDown" data-wow-delay="0s">DWG FastView Plus</h2>\
   <h3 class="wow fadeInUpSmall" data-wow-delay="0.2s">빠른 보기 & 유연한 측정 & 간편한 공유</h3>\
   <div class="btn wow fadeInUpSmall" id="footbntst" data-wow-delay="0.3s"><a href="javascript:;" v-on:click="googleDownload" class="n1 btnicon downlinkMar"><i></i><em>무료 사용</em></a><a href="javascript:;" class="n3 btnicon downlinkMar2"><i><img src="../static/images/krmony2.png" class="kr_requestQuote_icon kr_requestQuote_icon_normal"/><img src="../static/images/krmony2-hover.png" class="kr_requestQuote_icon kr_requestQuote_icon_hover"/></i><em>견적요청</em></a><a v-bind:href="buylink" v-on:click="googleBuyNow" class="n2 btnicon"><i></i><em>지금 구매</em></a></div>\
  </div>\
  <!--top-->\
  <div class="cl"></div>\
  <div class="bottom mainbox wow fadeIn">\
   <div class="left_cor">\
    <div class="foot_logo"><em></em>DWG FastView <i>+</i></div>\
    <div class="language">\
     <h3>언어</h3>\
     <ul>\
      <li><a href="javascript:;">한국어<i></i></a>\
       <dl>\
        <dt v-for="item in langlist"><a :href="item.linkurl">{{item.name}}</a></dt>\
       </dl>\
      </li>\
     </ul>\
    </div>\
    <!--language-->\
   </div>\
   <!--left_cor-->\
   <div class="right_cor">\
    <ul>\
     <li><h3>제품</h3></li>\
     <li><a href="#">DWG FastView Plus</a></li>\
    </ul>\
    <ul>\
     <li><h3>지원</h3></li>\
     <li><a href="userguide.html">문서</a></li>\
     <li><a href="videotutorials.html">동영상 튜토리얼</a></li>\
     <li><a href="emailus.html">기술 지원</a></li>\
     <li><a href="javascript:;" class="downlinkMar2">견적요청</a></li>\
    </ul>\
    <ul>\
     <li><h3>응용 사례</h3></li>\
     <li v-for="item in colunmlist"><a :href="\'content.html?id=\'+item.id">{{item.title}}</a></li>\
    </ul>\
   </div>\
   <!--right_cor-->\
  </div>\
  <!--bottom-->\
  <div class="dollow_us cl mainbox  wow fadeIn">\
   <h3>팔로우 하기</h3>\
   <span><a href="https://www.linkedin.com/company/2444016" target="_blank" class="icon1"><i></i></a><a href="https://www.youtube.com/channel/UCtYObLC_uoUtObVFx71Tn9w" target="_blank" class="icon2"><i></i></a><a href="https://www.facebook.com/DWG-FastView-Plus-968128393349711/" target="_blank" class="icon3"><i></i></a><a href="https://twitter.com/Gstarsoft_CAD" target="_blank" class="icon4"><i></i></a></span>\
  </div>\
  <p class="rightcopy  wow fadeIn">©Copyright 2019 Gstarsoft Co.,Ltd. All rights reserved.</p>\
  <div class="oem_mask"></div><div class="oem_mask_model">\
  <div class="oem_mask_header">\
  DWG FastView Plus\
            <span class="oem_mask_close" onclick="closeOemMask(this)"></span>\
        </div>\
        <div class="oem_mask_txt">이메일 주소를  입력하십시오,  24 시간 내에 이메일을 통해 설치 패키지를 보내드립니다. PC에서 다운로드 하십시오.</div>\
        <input class="oem_mask_input" type="text" value=""/>\
        <span class="oem_mask_error"></span>\
        <a class="oem_mask_btn" onclick="purchaseSubmit(this,\'kr\',\'확인\')">확인</a>\
  </div>\
  </div>\
 <div class="popover" id="morkest" style=" height:auto; position:absolute;">\
   <div class="top">견적요청</div> \
   <div class="con">\
	 <div class="email_us" style="padding-top:0; margin-top:0;">\
	    <form>\
		  <ul>\
		    <li><h6><i></i>이름</h6></li>\
			<li><input type="text" class="txt" v-model="xname" @focus="name_error=false"><span v-if="name_error==true" class="error">이름을 입력하십시오</span></li>\
		  </ul>\
		  <ul class="last">\
		    <li><h6><i></i>회사명</h6></li>\
			<li><input type="text" class="txt" v-model="company" @focus="company_error=false"><span v-if="company_error==true" class="error">회사명을 입력하십시오</span></li>\
		  </ul>\
		  <ul>\
		    <li><h6><i></i>이메일</h6></li>\
			<li><input type="text" class="txt" v-model="email" @focus="email_error=false"><span v-if="email_error==true" class="error">정확한 이메일 주소를 입력하십시오</span></li>\
		  </ul>\
		  <ul class="last">\
		    <li><h6><i></i>연락처</h6></li>\
			<li><input type="text" class="txt" v-model="phone"  @focus="phone_error=false"><span v-if="phone_error==true" class="error">핸드폰번호 형식을 정확히 입력하십시오</span></li>\
		  </ul>\
	 <div class="cl"></div>\
     <div class="bit">\
	   <h3>구매버전</h3>\
	   <div class="bit_con">\
	     <label><input type="radio" checked="checked" name="softwareVersion" value="1"><i></i>독립형 버전</label>\
         <label><input type="radio" name="softwareVersion" value="2"><i></i>네트웍 버전</label>\
	   </div>\
	 </div>\
	 <div class="bit">\
	   <h3>라이선스 기간 </h3>\
	   <div class="bit_con">\
	     <label><input type="radio" checked="checked" name="duration" value="1"><i></i>1년 라이선스</label>\
         <label><input type="radio" name="duration" value="2"><i></i>영구 라이선스 </label>\
	   </div>\
	 </div>\
	 <div class="cl"></div>\
	 <ul class="big">\
	  <li><h6><i></i>구매 수량</h6></li>\
	  <li><input type="text" class="txt" v-model="quantity" @focus="quantity_error=false"><span v-if="quantity_error==true" class="error">{{quantity_error_msg}}</span></li>\
	 </ul>\
	 <div class="btn"><a href="javascript:;" class="close requestQuote_maskbtn">취소</a><a href="javascript:;"  v-on:click="requestQuote" class="submit requestQuote_maskbtn">{{requestQuote_submit}}</a></div>\
	 </form>\
	 </div>\
  </div>\
 </div></div>\
',

});

Vue.component('header-cont', {
  props: ['onpages','buylink','othercss'],
  data(){
	  return {
		  langlist: [],
		  isopen:false,
		  checkedlang:'한국어',
		  bit:32,
		  lang:'kr'
	  }
  },
  created:function(){
		var self = this;
		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchLanguage',
			  data: {productId:ProductId,pageNo:0,pageSize:10},
			  'Content-Type':"application/json",
			  success:function(res){
				  self.langlist = res.bizData.list;
			  }
		  })

  },
  methods:{

    openselect:function(){

		var self = this;
		self.isopen = true;

	},

	checkedlag:function(code,name){

		var self = this;
		self.checkedlang = name;
		self.lang = code;
		self.isopen = false;

	},

	Getdownlink:function(){
		var self = this;
		$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/downInstallPackage ',
			  data: {productId:ProductId,versionId:1,lang:self.lang,bit:self.bit},
			  'Content-Type':"application/json",
			  success:function(res){

				  window.location.href=res.bizData.downloadLink
			  }
		  })

	}



  },
  template: '<div>\
	<div class="header down" v-bind:class="{bgf:othercss==1}"><a href="javascript:;" class="menu_bt"><span>Menu</span></a>\
  <div class="con">\
   <div class="logo"><a href="index.html"></a></div>\
    <div class="page-overlay">\
      <div class="nav">\
        <ul>\
          <li v-bind:class="{on:onpages==1}"><a href="index.html">DWG FastView<i>+</i></a></li>\
          <li v-bind:class="{on:onpages==2}"><a href="Learn-more.html">기능</a></li>\
          <li v-bind:class="{on:onpages==3}"><a href="support.html">지원</a></li>\
          <li v-bind:class="{on:onpages==4}"><a href="review.html">리뷰</a></li>\
          <li v-bind:class="{on:onpages==5}"><a href="case.html">응용 사례</a></li>\
        </ul>\
      </div>\
      <div class="header_btn"><a href="javascript:;" class="bt1 downbtn">다운로드</a><em></em><a href="buy.html" class="bt2"><span data-hover="구매">구매</span></a></div>\
    </div>\
    <!--page-overlay--> \
  </div>\
  <!--con-->\
</div>\
<div class="mask"></div>\
<a href="javascript:;" class="popover_close"></a>\
<div class="popover" id="dowmnmart">\
 <div class="top"><i></i>소프트웨어 다운로드</div>\
 <div class="con">\
  <div class="bit">\
   <h3>Version</h3>\
   <div class="bit_con">\
       <label><input type="radio" checked name="bit" v-model="bit" value="32"><i></i>32 bit</label>\
       <label><input type="radio" name="bit" v-model="bit" value="64"><i></i>64 bit</label>\
   </div>\
  </div>\
  <!--bit-->\
  <div class="language">\
    <h3>Language</h3>\
    <div class="select">\
      <div class="select_text" v-on:click="openselect">{{checkedlang}}</div>\
      <ul class="select_ul" v-if="isopen==true" style="display:block;">\
        <li v-for="item in langlist" v-on:click="checkedlag(item.code,item.name)">{{item.name}}</li>\
      </ul>\
    </div>\
    </div>\
    <!--language-->\
    <div class="btn"><a href="javascript:;" class="close">취소</a><a v-on:click="Getdownlink" class="submit" href="javascript:;">확인</a></div>\
 </div>\
 <!--con-->\
</div>\
<!--下载弹出-->\
</div>\
',

});

Vue.component('slider-cont', {
  props: ['onnav'],
  template: '<div class="left_side wow fadeInLeftSmall">\
  <ul>\
   <li><h2>문서</h2></li>\
   <li v-bind:class="{on:onnav==1}"><a href="userguide.html">사용자 가이드</a></li>\
   <li v-bind:class="{on:onnav==2}"><a href="howto.html">방법</a></li>\
  </ul>\
  <ul>\
   <li><h2>동영상</h2></li>\
   <li v-bind:class="{on:onnav==3}"><a href="productoverview.html">제품 개요</a></li>\
   <li v-bind:class="{on:onnav==4}"><a href="videotutorials.html">동영상 튜토리얼</a></li>\
  </ul>\
  <ul>\
   <li><h2>기술 지원</h2></li>\
   <li v-bind:class="{on:onnav==5}"><a href="emailus.html">이메일 보내기</a></li>\
   <li><a href="support.html">온라인 도움말</a></li>\
  </ul>\
  </div>',
});

Vue.component('down-cont', {
  template: '<div class="downcomone">\
	 <!--侧边栏-->\
	 <ul class="side-bar slideInRight">\
	  <li class="s1"><a href="#"><i></i></a></li>\
	  <li class="s2"><a href="#"><i></i></a></li>\
	  <li class="s3"><a href="#"><i></i></a></li>\
	 </ul>\
	<div class="mask"></div>\
	<a href="#" class="popover_close"></a>\
	<div class="popover">\
	 <div class="top"><i></i>Download Software</div>\
	 <div class="con">\
	 <form>\
	  <div class="bit">\
	   <h3>Version</h3>\
	   <div class="bit_con">\
		   <label><input type="radio" checked name="hot"><i></i>32 bit</label>\
		   <label><input type="radio" name="hot"><i></i>64 bit</label>\
	   </div>\
	  </div>\
	  <!--bit-->\
	  <div class="language">\
		<h3>Language</h3>\
		<select class="select">\
		  <option value ="0">English</option>\
		  <option value ="1" >한국어</option>\
		  <option value ="2" >日本语</option>\
		</select>\
		</div>\
		<!--language-->\
		<div class="btn"><a href="javscript:;" class="close">Cancel</a><input type="submit" value="Confirm"></div>\
	  </form>\
	 </div>\
	 <!--con-->\
	</div>\
	<!--下载弹出-->\
	</div>',
});

Vue.component('search-cont', {
  data(){
	  return {
		  key: '',
	  }
  },
  methods:{

	  search:function(){
		  var self= this;
		  window.location.href="result.html?key="+self.key;

	  }

  },
  template: '<div class="cases_banner">\
 <div class="mainbox">\
  <input type="text" @keyup.enter="search" v-model="key" placeholder="안녕하세요, 무엇을 도와 드릴까요?" class="text">\
  <button v-on:click="search"><i></i>지금 검색</button>\
 </div>\
</div>',
});





// WEBPACK FOOTER //
// ./static/kr/vue-components.js